import React, { useCallback, useState } from 'react';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { openVisionplanner } from '../../common/visionplanner';
import './NavMenu.css';
import { useAuthenticationStatus } from '../../common/queries/useAuthenticationStatus';
import { useVisionplannerDetails } from '../../common/queries/useVisionplannerDetails';

/** Navigation menu component */
export const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);

  const authenticationStatusQuery = useAuthenticationStatus();
  const useVisionPlannerDetailsQuery = useVisionplannerDetails();
  const visionplannerDetails = useVisionPlannerDetailsQuery?.data;

  const history = useHistory();

  const toggleNavbar = useCallback(() => {
    setCollapsed(old => !old);
  }, []);

  const handleOpenVisionplannerClick = useCallback(() => {
    openVisionplanner({
      visionplannerDetails,
    }).catch(console.error);
  }, [visionplannerDetails]);

  const handleLogoutClick = useCallback(async () => {
    await fetch('api/account/logout', { method: 'POST' });
    authenticationStatusQuery.refetch();
    history.push('/login');
  }, [authenticationStatusQuery, history]);

  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
        <Container>
          <NavbarBrand data-ta="home-link" tag={Link} to="/">Accountantsportaal</NavbarBrand>
          <NavbarToggler data-ta="toggle-menu-button" onClick={toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              {
                !authenticationStatusQuery.data?.isAuthenticated && (
                  <NavItem>
                    <NavLink data-ta="login-link" tag={Link} to="/login">Aanmelden</NavLink>
                  </NavItem>
                )
              }
              {
                !!authenticationStatusQuery.data?.isAuthenticated && (
                  <>
                    <NavItem>
                      <NavLink data-ta="open-vpc-button" tag={Button} color="link" className="border-0" onClick={handleOpenVisionplannerClick}>Visionplanner</NavLink>
                    </NavItem>
                    <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle nav caret data-ta="user-menu">
                        {authenticationStatusQuery.data?.username}
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem data-ta="logout-button" onClick={handleLogoutClick}>
                          Logout
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </>
                )
              }
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
